import { collection, getDocsFromServer, runTransaction } from 'firebase/firestore';
import { db } from '../services/firebase';
import type { Expense, ExpenseSettlement } from '../types';
import { writeSettlementChanges } from './settlementWrites';
import { writeExpenseCreate, writeExpenseDelete, writeExpenseEdit } from './expenseEdits';
import { assertSingleLegacyCharge } from './expenseLinks';
import { reserveLegacyCostReview } from './fullCostProtocol';

export function saveSettlementChanges(tripId: string, changes: { expense: Expense; userId: string; next: ExpenseSettlement | null }[]) {
  return saveScopedSettlementChanges(changes.map(change => ({ ...change, tripId })));
}

export function saveScopedSettlementChanges(changes: Parameters<typeof writeSettlementChanges>[2]) {
  return runTransaction(db, transaction => writeSettlementChanges(transaction, db, changes));
}
export function saveSettlementChange(tripId: string, expense: Expense, userId: string, next: ExpenseSettlement | null) {
  return saveSettlementChanges(tripId, [{ expense, userId, next }]);
}

export async function saveExpenseEdit(tripId: string, previous: Expense, next: Expense, userId: string, legacySource?: Record<string, unknown>) {
  if (legacySource) {
    await reserveLegacyCostReview(db, tripId, previous);
    // Server scan after acquiring the retained claim: old independent writers are fenced.
    const records = await getDocsFromServer(collection(db, 'trips', tripId, 'expenses'));
    assertSingleLegacyCharge(previous, records.docs.map(record => ({ ...record.data(), id: record.id } as Expense)));
  }
  return runTransaction(db, transaction => writeExpenseEdit(transaction, db, { tripId, previous, next, userId, legacySource }));
}

export function saveExpenseCreate(tripId: string, expense: Expense, userId: string) {
  return runTransaction(db, transaction => writeExpenseCreate(transaction, db, { tripId, expense, userId }));
}

export function saveExpenseDelete(tripId: string, previous: Expense) {
  return runTransaction(db, transaction => writeExpenseDelete(transaction, db, { tripId, previous }));
}
